import script from "./ShareNotePopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareNotePopover.vue?vue&type=script&setup=true&lang=js"

import "./ShareNotePopover.vue?vue&type=style&index=0&id=6bb9d5e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb9d5e4"]])

export default __exports__